<nz-card class="card-wrapper">
  <div class="card-header">
    <h4 nz-typography class="nfl-form-label">{{ data.name | titlecase }}</h4>
    <span nz-dropdown [nzDropdownMenu]="chartMenu" nzPlacement="bottomRight" nzTrigger="click" class="card-menu-icon">
      <span nz-icon nzType="more" nzTheme="outline"></span>
    </span>
    <nz-dropdown-menu #chartMenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item (click)="onMenuAction('view')" *ngIf="data.chartId && appService.isEngagementActive">
          <span nz-icon nzType="eye" nzTheme="outline"></span>
          View
        </li>
        <li nz-menu-item (click)="onMenuAction('edit')" *ngIf="appService.isEngagementActive">
          <span nz-icon nzType="edit" nzTheme="outline"></span>
          Edit
        </li>
        <li nz-menu-item (click)="onMenuAction('export')">
          <span nz-icon nzType="export" nzTheme="outline"></span>
          Export
        </li>
        <li nz-menu-item nzDanger (click)="onMenuAction('delete')" *ngIf="appService.isEngagementActive">
          <span nz-icon nzType="delete" nzTheme="outline"></span>
          Delete
        </li>
      </ul>
    </nz-dropdown-menu>
  </div>
  <div class="card-meta">
    <span class="nfl-form-label">{{ data.createdBy }}</span>
    <span class="card-separator">•</span>
    <span class="nfl-form-label">Modified: {{ data!.lastModifiedAt | date }}</span>
    <span class="card-separator" *ngIf="data?.chartId">•</span>
    <span class="nfl-form-label" *ngIf="data?.chartType">{{ data.chartType | titlecase }} Chart</span>
  </div>
  <div class="card-content">
    <img
      [src]="getImage(data)"
      [alt]="data.name"
      class="card-image"
      (click)="onImageClick()"
      [style.cursor]="data?.dashboardId ? 'pointer' : 'default'"
    />
    <div class="overlay" *ngIf="data.dashboardId">
      <span nz-icon nzType="expand" class="icon" nzTheme="outline"></span>
    </div>
  </div>
</nz-card>
